import {ReactNode} from "react";

export default function FieldGroup(props: {children?: ReactNode}) {
    return (
        <div className="space-y-6 sm:space-y-5">
            {props.children}
        </div>)
}